import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import styled from 'styled-components';
import { media } from 'styles/breakpoints';

const Container = styled.div``;
const Title = styled.h2`
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-style: italic;
  text-align: center;

  ${media.small`
    font-size: 32px;
    margin: 20px 0;
  `};
`;

const Text = styled.p`
  font-family: 'Lato', sans-serif;
  font-weight: 300;
  text-align: center;

  ${media.small`
    margin: 10px 0;
  `};
`;

export default function OnThisDay({ date }) {
  if (!date) return null;
  const dateObj = moment(date, 'MM-DD-YYYY');

  return (
    <Container>
      <Title>{`Today is ${dateObj.format('MMMM DD')}`}</Title>
      <Text>{`On this date in ${dateObj.format('YYYY')}...`}</Text>
    </Container>
  );
}

OnThisDay.propTypes = {
  date: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/components/OnThisDay/OnThisDay.js